export default {
  // Base colors
  primary: '#d9534f',
  secondary: '#004b8e',
  warning: '#f0ad4e',

  // Dark colors
  black: '#000000',
  dark1: '#9e9e9e',
  dark2: '#686868',
  dark3: '#333333',

  // Light colors
  white: '#FFFFFF',
  light1: '#F2F2F2',
  light2: '#D8D7D9',
  light3: '#C3C8D1',
};
